import React from "react";
import FrontendLayout from "../FrontendLayout";
import Hero from "../front-components/Hero";
import { Link } from "react-router-dom";

const Price = () => {
  return (
    <FrontendLayout>
      <Hero title="Pricing" />
      <div className="container-xxl py-5">
        <div className="container py-5">
          <div
            className="text-center wow fadeInUp"
            data-wow-delay="0.1s"
            style={{
              visibility: "visible",
              animationDelay: "0.1s",
              animationName: "fadeInUp",
            }}
          >
            <h6 className="text-secondary text-uppercase">Pricing Plan</h6>
            <h1 className="mb-5">Perfect Pricing Plan</h1>
            <p>
              We wanted to touch base regarding the pricing details for our
              transport services. We have several factors that influence our
              rates, including location, distance, truck selection, kilometers
              traveled, and weight (both in tons and kgs). To give our customers
              a clearer understanding of our services, we should reflect a
              starting price range of INR 2,000 up to INR 500,000. Additionally,
              I'd like to emphasize that there are more variations available
              based on specific requirements. If need a correct pricing details
              kindy use Quote option and enter the details approx pricing will
              be available,
            </p>
          </div>
          <div className="row g-4">
            <div
              className="col-md-6 col-lg-4 wow fadeInUp"
              data-wow-delay="0.3s"
              style={{
                visibility: "visible",
                animationDelay: "0.3s",
                animationName: "fadeInUp",
              }}
            >
              <div className="price-item">
                <div className="border-bottom p-4 mb-4">
                  <h5 className="text-primary mb-1 text-center">
                    Transport Services
                  </h5>
                  <h4 className="mb-0 mt-2 text-center">Rs 2000 to 499999</h4>
                </div>
                <div className="p-4 pt-0">             
                  <Link className="btn-slide mt-2" to={'/newQuote'}>
                    <i className="fa fa-arrow-right"></i>
                    <span>Order Now</span>
                  </Link>
                </div>
              </div>
            </div>
            <div
              className="col-md-6 col-lg-4 wow fadeInUp"
              data-wow-delay="0.3s"
              style={{
                visibility: "visible",
                animationDelay: "0.5s",
                animationName: "fadeInUp",
              }}
            >
              <div className="price-item">
                <div className="border-bottom p-4 mb-4">
                  <h5 className="text-primary mb-1 text-center">
                    Vehical Rent Services
                  </h5>
                  <h4 className="mb-0 mt-2 text-center">Rs 2000 to 199999</h4>
                </div>
                <div className="p-4 pt-0">             
                  <Link className="btn-slide mt-2" to={'/newQuote'}>
                    <i className="fa fa-arrow-right"></i>
                    <span>Order Now</span>
                  </Link>
                </div>
              </div>
            </div>
            <div
              className="col-md-6 col-lg-4 wow fadeInUp"
              data-wow-delay="0.3s"
              style={{
                visibility: "visible",
                animationDelay: "0.7s",
                animationName: "fadeInUp",
              }}
            >
              <div className="price-item">
                <div className="border-bottom p-4 mb-4">
                  <h5 className="text-primary mb-1 text-center">
                  Shipping Services
                  </h5>
                  <h4 className="mb-0 mt-2 text-center">Rs 2000 to 500000</h4>
                </div>
                <div className="p-4 pt-0">             
                  <Link className="btn-slide mt-2" to={'/newQuote'}>
                    <i className="fa fa-arrow-right"></i>
                    <span>Order Now</span>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </FrontendLayout>
  );
};

export default Price;
